module.exports = __webpack_public_path__ + "static/media/th-parachute-2.4772aaf0.svg";